export default function (value) {
  return /\s/.test(value.trim())
}
